'use client';
import { buildImageSrc } from '@repo/ui/src/functions/image-functions-aspect-ratio';
import { MediaType } from '@repo/ui/src/types/image';
import Button, { ButtonVariant } from '@repo/ui/src/components/Button';
import { Anchor } from '@repo/ui/src/components/Anchor';
import useTranslation from '../../context/Translation/useTranslation';

export interface AuthorCardProps {
  name: string;
  avatar: MediaType;
  title: string;
  _meta?: {
    deliveryKey: string;
  };
}

const AuthorCard = ({ name, avatar, title, _meta }: AuthorCardProps) => {
  const { t } = useTranslation();
  const imgUrl = avatar && buildImageSrc(avatar, 370, 3, 3);
  return (
    <div>
      {imgUrl && (
        /* eslint-disable-next-line @next/next/no-img-element */
        <img alt={title} src={imgUrl} className="image w-full object-cover object-center" />
      )}
      <div className="bg-white p-6" data-testid="text-container">
        {name && <h6 className="tra-text-web-heading-6 pb-5 text-left">{name}</h6>}
        {title && <hr className="border-2 w-6 border-brand-300" />}
        {title && <p className="tra-text-web-body-l text-left py-4">{title}</p>}
        {_meta?.deliveryKey && (
          <Button
            variant={ButtonVariant.knife}
            as={Anchor}
            link={_meta?.deliveryKey}
            className="h-auto"
            size="small"
          >
            {t('generalContent.learnMore', undefined, {
              default: 'Learn More',
            })}
          </Button>
        )}
      </div>
    </div>
  );
};

export default AuthorCard;
